import { WebAuthnError } from '@simplewebauthn/browser';
import { useCallback } from 'react';
import { handleAxiosError, message } from 'ui';

export const usePasskeyRegistrationError = () =>
  useCallback((error: Error) => {
    if (error instanceof WebAuthnError) {
      switch (error.code) {
        case 'ERROR_AUTHENTICATOR_MISSING_DISCOVERABLE_CREDENTIAL_SUPPORT':
        case 'ERROR_AUTHENTICATOR_MISSING_USER_VERIFICATION_SUPPORT':
        case 'ERROR_AUTHENTICATOR_NO_SUPPORTED_PUBKEYCREDPARAMS_ALG':
        case 'ERROR_MALFORMED_PUBKEYCREDPARAMS':
          message.error('Passkey creation is not available on this device');
          return;
        case 'ERROR_AUTHENTICATOR_PREVIOUSLY_REGISTERED':
          message.error("The passkey you're trying to create is already in use on this device");
          return;
        case 'ERROR_CEREMONY_ABORTED':
        case 'ERROR_PASSTHROUGH_SEE_CAUSE_PROPERTY':
          message.error('You canceled the passkey creation process');
          return;
        case 'ERROR_AUTHENTICATOR_GENERAL_ERROR':
        case 'ERROR_AUTO_REGISTER_USER_VERIFICATION_FAILURE':
        case 'ERROR_INVALID_DOMAIN':
        case 'ERROR_INVALID_RP_ID':
        case 'ERROR_INVALID_USER_ID_LENGTH':
        case 'ERROR_SIGNAL_INVALID_ARGUMENT':
          message.error('Passkey creation failed for an unknown reason');
      }
    } else {
      handleAxiosError(error, 'Passkey creation failed for an unknown reason');
    }
  }, []);
